import remotePatterns from '../../../config/remote-patterns'

interface IRemotePattern {
  protocol: string
  hostname: string
  // Enforced by next/image itself; this runtime guard matches on host only.
  port?: string
  pathname?: string
}

const patterns: IRemotePattern[] = remotePatterns

// Mirrors next/image remotePatterns semantics: '**.' matches subdomains at
// any depth, not the apex domain.
const matchesHostname = (hostname: string, pattern: string): boolean =>
  pattern.startsWith('**.')
    ? hostname.endsWith(pattern.slice(2))
    : hostname === pattern

/**
 * True when `src` is safe to hand to next/image: relative (same-origin) or an
 * absolute URL whose host matches the next.config remotePatterns allowlist.
 * Unknown hosts must fall back to a plain <img> — next/image throws at render
 * for unconfigured hostnames, which would take down the whole layout on a
 * config typo.
 */
export const isAllowedImageSrc = (src: string): boolean => {
  if (src.startsWith('/') && !src.startsWith('//')) return true
  try {
    const url = new URL(src)
    return patterns.some((pattern) =>
      `${pattern.protocol}:` === url.protocol &&
      matchesHostname(url.hostname, pattern.hostname)
    )
  } catch {
    return false
  }
}
